<template>
  <!-- 资金安全 · 平台核心数字资产高级防护体系（三卡信息图的 HTML/CSS 复刻） -->
  <div class="protection-system">
    <header class="protection-head">
      <h4 class="protection-title">{{ $t("fundSafety.d2Title") }}</h4>
      <p class="protection-subtitle">{{ $t("fundSafety.d2Subtitle") }}</p>
    </header>

    <div class="protection-grid">
      <!-- 1. 多重授权 -->
      <article class="protection-card">
        <div class="protection-icon">
          <Lock :size="20" />
        </div>
        <h5 class="protection-card-title">
          {{ $t("fundSafety.d2C1Title") }}
        </h5>
        <p class="protection-point">{{ $t("fundSafety.d2C1Point") }}</p>
        <p class="protection-text">{{ $t("fundSafety.d2C1Text") }}</p>
        <p class="protection-badge">🔑 {{ $t("fundSafety.d2C1Badge") }}</p>
      </article>

      <!-- 2. 资产安全存储（高亮） -->
      <article class="protection-card protection-card--active">
        <div class="protection-icon protection-icon--shield">
          <Shield :size="22" />
        </div>
        <h5 class="protection-card-title">
          {{ $t("fundSafety.d2C2Title") }}
        </h5>
        <p class="protection-tag">{{ $t("fundSafety.d2C2Tag") }}</p>
        <div class="protection-wallet protection-wallet--hot">
          <strong>{{ $t("fundSafety.d2C2HotTitle") }}</strong>
          <span>{{ $t("fundSafety.d2C2HotText") }}</span>
        </div>
        <div class="protection-wallet protection-wallet--cold">
          <strong>{{ $t("fundSafety.d2C2ColdTitle") }}</strong>
          <span>{{ $t("fundSafety.d2C2ColdText") }}</span>
        </div>
      </article>

      <!-- 3. 多层风控监测 -->
      <article class="protection-card protection-card--risk">
        <div class="protection-icon protection-icon--green">
          <Radar :size="20" />
        </div>
        <h5 class="protection-card-title">
          {{ $t("fundSafety.d2C3Title") }}
        </h5>
        <p class="protection-point">{{ $t("fundSafety.d2C3Point") }}</p>
        <p class="protection-text">{{ $t("fundSafety.d2C3Text") }}</p>
        <p class="protection-badge">⚡ {{ $t("fundSafety.d2C3Badge") }}</p>
      </article>
    </div>
  </div>
</template>

<script>
import { Lock, Shield, Radar } from "lucide-vue";

export default {
  name: "FundProtectionSystem",
  components: {
    Lock,
    Shield,
    Radar,
  },
};
</script>

<style scoped>
.protection-system {
  padding: 24px 26px 26px;
  border-radius: 16px;
  border: 1px solid rgba(0, 180, 255, 0.14);
  background: radial-gradient(
      120% 130% at 50% 0%,
      rgba(37, 99, 235, 0.16),
      transparent 60%
    ),
    linear-gradient(180deg, #0a1727 0%, #060b14 100%);
  box-shadow: 0 24px 48px -34px rgba(0, 0, 0, 0.95);
}

.protection-head {
  margin: 0 0 22px;
  text-align: center;
}

.protection-title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.4;
  letter-spacing: 0.3px;
  color: #fff;
}

.protection-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.5);
}

.protection-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.protection-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 22px 18px 20px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.045),
    rgba(255, 255, 255, 0.012)
  );
  text-align: center;
}

.protection-card--active {
  border-color: rgba(37, 99, 235, 0.8);
  background: linear-gradient(
    180deg,
    rgba(29, 78, 216, 0.18),
    rgba(10, 20, 40, 0.4)
  );
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.25),
    0 22px 40px -30px rgba(37, 99, 235, 0.95);
}

.protection-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid rgba(56, 189, 248, 0.45);
  background: rgba(0, 180, 255, 0.14);
  color: #38bdf8;
  box-shadow: 0 0 18px -6px rgba(56, 189, 248, 0.7);
}

.protection-icon--shield {
  border-color: rgba(59, 130, 246, 0.65);
  background: rgba(37, 99, 235, 0.25);
  color: #60a5fa;
}

.protection-icon--green {
  border-color: rgba(34, 197, 94, 0.5);
  background: rgba(16, 185, 129, 0.14);
  color: #34d399;
  box-shadow: 0 0 18px -6px rgba(52, 211, 153, 0.7);
}

.protection-card-title {
  margin: 0;
  font-size: 15.5px;
  font-weight: 700;
  line-height: 1.4;
  color: #38bdf8;
}

.protection-card--risk .protection-card-title {
  color: #34d399;
}

.protection-point {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.5;
  color: #e2e8f0;
}

.protection-point::before {
  content: "";
  flex: 0 0 auto;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #38bdf8;
}

.protection-text {
  margin: 0;
  font-size: 12px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.55);
}

.protection-badge {
  margin: auto 0 0;
  padding-top: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  color: #fff;
}

.protection-tag {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: #38bdf8;
}

.protection-wallet {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px;
  border-radius: 10px;
  text-align: center;
}

.protection-wallet strong {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
}

.protection-wallet span {
  font-size: 11px;
  line-height: 1.6;
}

.protection-wallet--hot {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.08);
}

.protection-wallet--hot strong {
  color: #e5e7eb;
}

.protection-wallet--hot span {
  color: rgba(255, 255, 255, 0.5);
}

.protection-wallet--cold {
  border: 1px solid rgba(52, 211, 153, 0.55);
  background: linear-gradient(
    135deg,
    rgba(16, 185, 129, 0.3),
    rgba(6, 95, 70, 0.42)
  );
}

.protection-wallet--cold strong {
  color: #6ee7b7;
}

.protection-wallet--cold span {
  color: rgba(209, 250, 229, 0.82);
}

@media (max-width: 900px) {
  .protection-system {
    padding: 18px 16px 20px;
  }

  .protection-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
  }
}
</style>
